import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The day my elaborate prank failed",
  "description": "",
  "published": "2009-04-01T00:00:00.000Z",
  "redirect_from": ["/blog/the-day-my-elaborate-prank-failed/swizec/483"],
  "categories": "funny, Humor, Joke, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Senior_Prank_2007.jpg"
          }}><img parentName="a" {...{
              "src": "https://upload.wikimedia.org/wikipedia/en/thumb/6/6b/Senior_Prank_2007.jpg/202px-Senior_Prank_2007.jpg",
              "alt": "Palo Alto High School",
              "title": "Palo Alto High School"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Senior_Prank_2007.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Today is the very first of April, which by some strange and odd tradition means we should make fun of every fool we can find. Stranger still, it means every tech guy, company and anyone who thinks they know technology is mandated to prepare a prank for someone.`}</p>
    <p>{`And I did. I spent well over an hour last night preparing my prank.`}</p>
    <p>{`And it didn't work. Failed so miserably I could almost say the joke was on me!`}</p>
    <p>{`What I tried to do was reroute all traffic on the company's webserver so that when an image is requested it doesn't come from where it usually comes from, but rather go through an intermediary, which would twist and turn and colorise and grayscale and whatnot the image until it became something odd and strange. The plan was that people in the company would notice this and make a huge hissy panic.`}</p>
    <p>{`But instead ... nothing happened. One page failed to display images, the others barely even reacted due to caching in browsers.`}</p>
    <p>{`*`}{`sigh`}{`*`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/1b5207c7-e882-4407-b023-e1d202df1e7d/",
        "title": "Zemified by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=1b5207c7-e882-4407-b023-e1d202df1e7d",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      